var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProofOfIncome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25368_25047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.125 18.5002C28.5747 18.5002 29.75 17.325 29.75 15.8752C29.75 14.4255 28.5747 13.2502 27.125 13.2502C25.6753 13.2502 24.5 14.4255 24.5 15.8752C24.5 17.325 25.6753 18.5002 27.125 18.5002Z",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 27.5002H9.5C9.30109 27.5002 9.11032 27.4212 8.96967 27.2806C8.82902 27.1399 8.75 26.9492 8.75 26.7502V23.0002C8.75 22.8013 8.82902 22.6106 8.96967 22.4699C9.11032 22.3293 9.30109 22.2502 9.5 22.2502H12.5",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.0003H21.5L27.7812 21.5556C28.0122 21.4923 28.2546 21.4831 28.4897 21.5287C28.7247 21.5744 28.9461 21.6736 29.1365 21.8187C29.327 21.9639 29.4814 22.1509 29.5878 22.3655C29.6942 22.58 29.7497 22.8161 29.75 23.0556C29.7501 23.3447 29.6697 23.6281 29.5176 23.874C29.3656 24.1199 29.148 24.3186 28.8894 24.4478L25.25 26.0003L19.25 27.5003H12.5V22.2503L14.8438 19.9065C15.0532 19.6977 15.3018 19.5323 15.5753 19.4197C15.8488 19.3071 16.1418 19.2495 16.4375 19.2503H21.125C21.6223 19.2503 22.0992 19.4478 22.4508 19.7994C22.8025 20.1511 23 20.628 23 21.1253C23 21.6225 22.8025 22.0994 22.4508 22.4511C22.0992 22.8027 21.6223 23.0003 21.125 23.0003H18.5Z",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4973 15.9982C23.9878 16.2392 23.4143 16.3098 22.8616 16.1996C22.309 16.0893 21.8064 15.8042 21.4283 15.3862C21.0502 14.9683 20.8167 14.4398 20.7623 13.8788C20.7078 13.3179 20.8354 12.7543 21.126 12.2715C21.4167 11.7886 21.855 11.4121 22.3762 11.1977C22.8974 10.9833 23.4738 10.9422 24.02 11.0807C24.5663 11.2192 25.0536 11.5299 25.4097 11.9667C25.7657 12.4035 25.9718 12.9434 25.9973 13.5064",
    stroke: "#E01E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25368_25047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.00024)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfIncome);
export default __webpack_public_path__ + "static/media/proofOfIncome.8ed0fc2e1984ea0242050f95dad86eec.svg";
export { ForwardRef as ReactComponent };